<template>
  <section>
    <div class="card-band-styling">
      <h2>Register</h2>
      <h3>Name</h3>
      <div>
        <div class="dynamic-grid">
          <div>
            First Name*
            <div>
              <input type="text" v-model="inputObjectData.firstName" />
              <div id="errorFirstName" class="warning-alert">
              </div>
            </div>
          </div>
          <div>
            Middle Name
            <div>
              <input type="text" v-model="inputObjectData.middleName" />
              <div id="errorMiddleName" class="warning-alert">
              </div>
            </div>
          </div>
          <div>
            Last Name*
            <div>
              <input type="text" v-model="inputObjectData.lastName" />
              <div id="errorLastName" class="warning-alert">
              </div>
            </div>
          </div>
        </div>
        <div class="dynamic-grid">
          <div>
            Pronouns*
            <div>
              <select v-model="inputObjectData.pronouns">
                <option>He/Him</option>
                <option>She/Her</option>
                <option>They/Them</option>
                <option>He/They</option>
                <option>She/They</option>
                <option>Other</option>
                <option>Prefer Not to Say</option>
              </select>
              <div id="errorPronouns" class="warning-alert">
              </div>
            </div>
          </div>
          <div>
            Access Role*
            <div>
              <select v-model="inputObjectData.accessRole">
                <option value="App User">App User</option>
                <option value="App Admin">App Admin</option>
                <option value="Developer">Developer</option>
                <option value="Organization">Organization</option>
                <option value="Parent/Caretaker">Parent/Caretaker</option>
                <option value="Specialist">Specialist</option>
                <option value="Statistician/Analyst">Statistician/Analyst</option>
                <option value="Super Admin">Super Admin</option>
              </select>
              <div id="errorAccessRole" class="warning-alert">
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3>Work</h3>
      <div>
        <div class="dynamic-grid">
          <div>
            Job Title*
            <div>
              <input type="text" v-model="inputObjectData.jobTitle" />
              <div id="errorJobTitle" class="warning-alert">
              </div>
            </div>
          </div>
          <div>
            Department*
            <div>
              <input type="text" v-model="inputObjectData.department" />
              <div id="errorDepartment" class="warning-alert">
              </div>
            </div>
          </div>
        </div>
        <div class="dynamic-grid">
          <div>
            Type of Specialist
            <div>
              <select v-model="inputObjectData.specialistType">
                <option value="">Not a Specialist</option>
                <option value="Child Counselor">Child Counselor</option>
                <option value="Language Therapist">Language Therapist</option>
                <option value="Neuro-pediatrician">Neuro-pediatrician</option>
                <option value="Occupational Therapist (OT)">Occupational Therapist (OT)</option>
                <option value="Occupational Therapist Assistant (OTA)">Occupational Therapist Assistant (OTA)</option>
                <option value="Physical Therapist/Kinesiologist">Physical Therapist/Kinesiologist</option>
                <option value="Psychotherapist">Psychotherapist</option>
                <option value="Psychologist">Psychologist</option>
                <option value="Reading Specialist (RSP)">Reading Specialist (RSP)</option>
                <option value="Social Worker">Social Worker</option>
                <option value="Special Education Teacher">Special Education Teacher</option>
                <option value="Speech & Language Pathologist (SLP)">Speech & Language Pathologist (SLP)</option>
                <option value="Speech & Language Pathologist Assistant (SLPA)">Speech & Language Pathologist Assistant (SLPA)</option>
                <option value="Speech Therapist">Speech Therapist</option>
              </select>
              <div id="errorSpecialistType" class="warning-alert">
              </div>
            </div>
          </div>
          <div>
            Certification
            <div>
              <input type="text" v-model="inputObjectData.certification"/>
            </div>
          </div>
        </div>
      </div>
      <h3>Location</h3>
      <div>
        <div class="dynamic-grid">
          <div>
            Address 1*
            <div>
              <input type="text" v-model="inputObjectData.address1" />
              <div id="errorAddress1" class="warning-alert">
              </div>
            </div>
          </div>
          <div>
            Address 2
            <div>
              <input type="text" v-model="inputObjectData.address2" />
            </div>
          </div>
        </div>
        <div class="dynamic-grid">
          <div>
            City*
            <div>
              <input type="text" v-model="inputObjectData.city" />
              <div id="errorCity" class="warning-alert">
              </div>
            </div>
          </div>
          <div>
            Sate or Province*
            <div>
              <input type="text" v-model="inputObjectData.stateOrProvince" />
              <div id="errorStateOrProvince" class="warning-alert">
              </div>
            </div>
          </div>
        </div>
        <div class="dynamic-grid">
          <div>
            Country*
            <div>
              <input type="text" v-model="inputObjectData.country" />
              <div id="errorCountry" class="warning-alert">
              </div>
            </div>
          </div>
          <div>
            Zip or Postal Code*
            <div>
              <input type="text" v-model="inputObjectData.zipCode" />
              <div id="errorZipCode" class="warning-alert">
              </div>
            </div>
          </div>
        </div>
        <div class="dynamic-grid">
          <div>
            Phone Number*
            <div>
              <input type="text" v-model="inputObjectData.phoneNumber" />
              <div id="errorPhoneNumber" class="warning-alert">
              </div>
            </div>
          </div>
          <div>
            Alternative Phone
            <div>
              <input type="text" v-model="inputObjectData.alternativePhone" />
              <div id="errorAlternativePhone" class="warning-alert">
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3>Create Login</h3>
      <div>
        <div>Email Address*</div>
        <div>
          <input type="email" v-model="inputObjectData.email"/>
          <div id="errorEmail" class="warning-alert">
          </div>
        </div>
        <div>Password*</div>
        <div>
          <input v-if="passwordShow1 == false" type="password" v-model="inputObjectData.password" />
          <input v-if="passwordShow1" type="text" v-model="inputObjectData.password" />
          <b-icon-eye-fill v-if="passwordShow1 == false" style="margin-left: -30px; cursor: pointer;" @click="togglePassword('1')"></b-icon-eye-fill>
          <b-icon-eye-slash-fill v-if="passwordShow1" style="margin-left: -30px; cursor: pointer;" @click="togglePassword('1')"></b-icon-eye-slash-fill>
          <div id="errorPassword" class="warning-alert">
          </div>
        </div>
        <div>Confirm Password*</div>
        <div>
          <input v-if="passwordShow2 == false" type="password" v-model="inputObjectData.confirmPassword" />
          <input v-if="passwordShow2" type="text" v-model="inputObjectData.confirmPassword" />
          <b-icon-eye-fill v-if="passwordShow2 == false" style="margin-left: -30px; cursor: pointer;" @click="togglePassword('2')"></b-icon-eye-fill>
          <b-icon-eye-slash-fill v-if="passwordShow2" style="margin-left: -30px; cursor: pointer;" @click="togglePassword('2')"></b-icon-eye-slash-fill>
          <div id="errorConfirmPassword" class="warning-alert">
          </div>
        </div>
      </div>
      <div class="button-container">
        <button v-if="loadingRegister">
          <b-spinner small></b-spinner>
          Register
        </button>
        <button v-else @click="submit">
          Register
        </button>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
  @use 'sharedSCSS/globalSharedVariables';

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Roboto', sans-serif;
  }

  input {
    width: 100%;
  }

  .card-band-styling {
    width: 75%;
  }

  .warning-alert {
    background-color: #ED7878;
    border-radius: 5px;
    margin: 5px 0;
  }

  h2 {
    text-align: center;
  }

  select {
    width: 100%;
  }

  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .dynamic-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    column-gap: 3rem;
  }
</style>

<script>
  import instance from "../axios.js";
  import { BIconEyeFill, BIconEyeSlashFill } from "bootstrap-vue";

  export default {
    name: "Register",
    components: {
      BIconEyeFill,
      BIconEyeSlashFill,
    },

    data() {
      return {
        inputObjectData: {
          firstName: '',
          middleName: '',
          lastName: '',
          pronouns: '',
          accessRole: 'App User',
          specialistType: '',
          certification: '',
          jobTitle: '',
          department: '',
          address1: '',
          address2: '',
          city: '',
          stateOrProvince: '',
          country: '',
          zipCode: '',
          phoneNumber: '',
          alternativePhone: '',
          email: '',
          password: '',
          confirmPassword: ''
        },
        passwordShow1: false,
        passwordShow2: false,
        errors: {},
        loadingRegister: false,
      };
    },
    methods: {
      togglePassword(number) {
        if (number == "1") {
          this.passwordShow1 = !this.passwordShow1;
        }

        if (number == "2") {
          this.passwordShow2 = !this.passwordShow2;
        }
      },
      validateEmail(email) {
        if (!email || email == 0) {
          return { valid: false, error: "This field is required" };
        }
        if (email.match(/^\w+([.-]?\w+)_@\w+(_[_.-]?\w+)_(.\w{2,3})+$/)) {
          return {
            valid: false,
            error: "Please enter a valid email.",
          };
        }
        return { valid: true, error: null };
      },
      validatePassword(password) {
        if (!password || password.length == 0) {
          return { valid: false, error: "This field is required" };
        }
        if (password.length < 8) {
          return {
            valid: false,
            error: "Password requires at least 8 characters",
          };
        }
        if (
          !/[~`!#$%@&*+=\-';,/{}|":<>]/g.test(password) ||
          !/\d/.test(password)
        ) {
          return {
            valid: false,
            error:
              "Password requires at least 1 number and 1 special character (e.g. '$', '%', '@').",
          };
        }
        return { valid: true, error: null };
      },
      validateConfirmPassword(confirmPassword, password) {
        if (!confirmPassword || confirmPassword.length == 0) {
          return { valid: false, error: "This field is required" };
        }
        if (confirmPassword != password) {
          return {
            valid: false,
            error: "The passwords you entered did not match",
          };
        }

        return { valid: true, error: null };
      },
      validatePronoun(pronoun) {
        if (pronoun === null || pronoun.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateFirstName(firstName) {
        if (firstName === null || firstName.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateLastName(lastName) {
        if (lastName === null || lastName.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateRole(role) {
        if (role === null || role.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateUserLevel(userLevel) {
        if (userLevel === null || userLevel.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateAddressLine1(addressLine1) {
        if (addressLine1 === null || addressLine1.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateJobTitle(jobTitle) {
        if (jobTitle === null || jobTitle.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateDepartment(department) {
        if (department === null || department.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateCountry(country) {
        if (country === null || country.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateState(state) {
        if (state === null || state.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateCity(city) {
        if (city === null || city.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validateZipCode(zipcode) {
        if (zipcode === null || zipcode.length === 0) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      validatePhoneNumber(phone) {
        if ((phone === null || phone.length === 0) && phone.length !== 10) {
          return { valid: false, error: "This field is required" };
        }
        return { valid: true, error: null };
      },
      submit() {
        this.loadingRegister = true;

        document.getElementById('errorFirstName').innerText = '';
        document.getElementById('errorMiddleName').innerText = '';
        document.getElementById('errorLastName').innerText = '';
        document.getElementById('errorPronouns').innerText = '';
        document.getElementById('errorAccessRole').innerText = '';
        document.getElementById('errorSpecialistType').innerText = '';
        document.getElementById('errorJobTitle').innerText = '';
        document.getElementById('errorDepartment').innerText = '';
        document.getElementById('errorAddress1').innerText = '';
        document.getElementById('errorCity').innerText = '';
        document.getElementById('errorStateOrProvince').innerText = '';
        document.getElementById('errorCountry').innerText = '';
        document.getElementById('errorZipCode').innerText = '';
        document.getElementById('errorPhoneNumber').innerText = '';
        document.getElementById('errorAlternativePhone').innerText = '';
        document.getElementById('errorEmail').innerText = '';
        document.getElementById('errorPassword').innerText = '';
        document.getElementById('errorConfirmPassword').innerText = '';

        this.errors = {};
        let valid = true;

        const validPronouns = this.validatePronoun(this.inputObjectData.pronouns);
        if (!validPronouns.valid) {
          valid = false;
          document.getElementById('errorPronouns').innerText = validPronouns.error;
        }
        const validFirstName = this.validateFirstName(this.inputObjectData.firstName);
        if (!validFirstName.valid) {
          valid = false;
          document.getElementById('errorFirstName').innerText = validFirstName.error;
        }
        const validLastName = this.validateLastName(this.inputObjectData.lastName);
        if (!validFirstName.valid) {
          valid = false;
          document.getElementById('errorLastName').innerText = validLastName.error;
        }
        const validAcessRole = this.validateUserLevel(this.inputObjectData.accessRole);
        if (!validAcessRole.valid) {
          valid = false;
          document.getElementById('errorAccessRole').innerText = validAcessRole.error;
        }
        const validJobTitle = this.validateJobTitle(this.inputObjectData.jobTitle);
        if (!validJobTitle.valid) {
          valid = false;
          document.getElementById('errorJobTitle').innerText = validJobTitle.error;
        }
        const validDepartment = this.validateDepartment(this.inputObjectData.department);
        if (!validDepartment.valid) {
          valid = false;
          document.getElementById('errorDepartment').innerText = validDepartment.error;
        }
        const validAddressLine1 = this.validateAddressLine1(this.inputObjectData.address1);
        if (!validAddressLine1.valid) {
          valid = false;
          document.getElementById('errorAddress1').innerText = validAddressLine1.error;
        }
        const validCountry = this.validateCountry(this.inputObjectData.country);
        if (!validCountry.valid) {
          valid = false;
          document.getElementById('errorCountry').innerText = validCountry.error;
        }
        const validState = this.validateState(this.inputObjectData.stateOrProvince);
        if (!validState.valid) {
          valid = false;
          document.getElementById('errorStateOrProvince').innerText = validState.error;
        }
        const validCity = this.validateCity(this.inputObjectData.city);
        if (!validCity.valid) {
          valid = false;
          document.getElementById('errorCity').innerText = validCity.error;
        }
        const validZipCode = this.validateZipCode(this.inputObjectData.zipCode);
        if (!validZipCode.valid) {
          valid = false;
          document.getElementById('errorZipCode').innerText = validZipCode.error;
        }
        const validPhoneNumber = this.validatePhoneNumber(this.inputObjectData.phoneNumber);
        if (!validPhoneNumber.valid) {
          valid = false;
          document.getElementById('errorPhoneNumber').innerText = validPhoneNumber.error;
        }
        const validEmail = this.validateEmail(this.inputObjectData.email);
        if (!validEmail.valid) {
          valid = false;
          document.getElementById('errorEmail').innerText = validEmail.error;
        }
        const validPassword = this.validatePassword(this.inputObjectData.password);
        if (!validPassword.valid) {
          valid = false;
          document.getElementById('errorPassword').innerText = validPassword.error;
        }
        const validConfirmPassword = this.validateConfirmPassword(this.inputObjectData.confirmPassword,this.inputObjectData.password);
        if (!validConfirmPassword.valid) {
          valid = false;
          document.getElementById('errorConfirmPassword').innerText = validConfirmPassword.error;
        }

        if (valid) {
          let dataToSubmit = {
            name: this.inputObjectData.firstName + " " + this.inputObjectData.middleName + ". " + this.inputObjectData.lastName,
            pronouns: this.inputObjectData.pronouns,
            access_role: this.inputObjectData.accessRole,
            job_title: this.inputObjectData.jobTitle,
            department: this.inputObjectData.department,
            type_of_specialist: this.inputObjectData.siteName,
            certification: this.inputObjectData.certification,
            address_1: this.inputObjectData.address1,
            address_2: this.inputObjectData.address2,
            city: this.inputObjectData.city,
            state: this.inputObjectData.stateOrProvince,
            country: this.inputObjectData.country,
            zip_code: this.inputObjectData.zipCode,
            phone_number: this.inputObjectData.phoneNumber,
            alternate_phone_number: this.inputObjectData.alternativePhone,
            email: this.inputObjectData.email,
            password: this.inputObjectData.password,
          };

          instance.post("api/auth/register",dataToSubmit)
            .then((response) => {
              if (!response.data.error) {
                this.loadingRegister = false;
                this.$router.push("/");
              } else if (response.data.error == "email already exists") {
                this.loadingRegister = false;
                alert("This email is already registered.");
              } else {
                this.loadingRegister = false;
                alert("An Error has occured");
              }
            })
            .catch((error) => {
              this.loadingRegister = false;
              console.log("There was a registration problem");
              console.log(error);
            });
        } else {
          this.loadingRegister = false;
        }
      }
    },
  };
</script>
